import { render, staticRenderFns } from "./dzOrderList.vue?vue&type=template&id=36f6033a&scoped=true&"
import script from "./dzOrderList.vue?vue&type=script&lang=js&"
export * from "./dzOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6033a",
  null
  
)

export default component.exports